import { pickResponse } from '@api/utils';
import Axios from 'axios-observable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenericLocationItem, LocationIQ } from './types';
import { windowObj } from '@lib/common';

export function locationIqSearch(
  query: string,
  limit: number = 10
): Observable<GenericLocationItem[]> {
  return Axios.get<LocationIQ.AutoCompleteResult[]>(
    `${windowObj.RAZZLE_LOCATION_IQ_API}/v1/autocomplete.php`,
    {
      params: {
        key: windowObj.RAZZLE_LOCATION_IQ_API_KEY,
        q: query,
        tag:
          'boundary:administrative' +
          ',place:country,place:city,place:state,place:region,place:province,place:district,place:county' +
          ',place:borough,place:suburb,place:quarter,place:city_block,place:town,place:municipality',
        // '',
        limit,
        dedupe: 1,
      },
    }
  ).pipe(
    pickResponse(),
    map(result =>
      result.map(loc => ({
        name: loc.display_place.replace(/,/g, '.'),
        subHeader: loc.display_address || '',
        country: loc.address?.country,
        countryCode: loc.address?.country_code,
        state: resolveState(loc), //loc.type === 'state' ? loc.display_place : loc.address.state,
        city: resolveCity(loc), //loc.type === 'city' ? loc.display_place : loc.address.city,
        lat: +loc.lat,
        lng: +loc.lon,
        type: loc.type.toLowerCase(),
        uuid: loc.place_id,
      }))
    )
  );
}
export function filmingLocationIqSearch(
  query: string,
  limit: number = 10
): Observable<GenericLocationItem[]> {
  return Axios.get<LocationIQ.AutoCompleteResult[]>(
    `${windowObj.RAZZLE_LOCATION_IQ_API}/v1/autocomplete.php`,
    {
      params: {
        key: windowObj.RAZZLE_LOCATION_IQ_API_KEY,
        q: query,
        tag:
          'place:country,place:city,place:state,place:district,place:county',
        // '',
        limit,
        dedupe: 1,
      },
    }
  ).pipe(
    pickResponse(),
    map(result => 
      result.map(loc => ({
        name: loc.display_place.replace(/,/g, '.'),
        subHeader: loc.display_address || '',
        country: loc.address?.country,
        countryCode: loc.address?.country_code,
        state: resolveState(loc), //loc.type === 'state' ? loc.display_place : loc.address.state,
        city: resolveCity(loc), //loc.type === 'city' ? loc.display_place : loc.address.city,
        lat: +loc.lat,
        lng: +loc.lon,
        type: loc.type.toLowerCase(),
        uuid: loc.place_id,
      }))
    )
  );
}
function resolveCity(loc: LocationIQ.AutoCompleteResult) {
  // Check if it has a city in address.
  if (loc.address.city) {
    return loc.address.city;
  }
  // Check if
  if (loc.class === 'place' && !['state', 'country'].includes(loc.type)) {
    return loc.display_place;
  }
  if (loc.class === 'boundary' && loc.address.state) {
    return loc.display_place;
  }
  return '';
}

function resolveState(loc: LocationIQ.AutoCompleteResult) {
  if (loc.address.state) {
    return loc.address.state;
  }
  if (loc.class === 'place' && loc.type === 'state') {
    return loc.display_place;
  }
  if (loc.class === 'boundary') {
    return loc.display_place;
  }
  return '';
}

export function locationIqForward(
  query: string,
  limit: number = 10
): Observable<GenericLocationItem[]> {
  return Axios.get<LocationIQ.AutoCompleteResult[]>(
    `${windowObj.RAZZLE_LOCATION_IQ_API}/v1/search.php`,
    {
      params: {
        key: windowObj.RAZZLE_LOCATION_IQ_API_KEY,
        q: query,
        tag: 'boundary:administrative,place:city,place:state,place:country,place:district',
        limit,
        format: 'json',
        addressdetails: 1,
        // dedupe: 1,
      },
    }
  ).pipe(
    pickResponse(),
    map(result =>
      result.map(loc => ({
        name: loc.display_place || loc.display_name,
        subHeader: loc.display_address || '',
        country: loc.address?.country,
        countryCode: loc.address?.country_code,
        state: loc.type === 'state' ? loc.display_place : loc.address.state,
        city: loc.type === 'city' ? loc.display_place : loc.address.city,
        lat: +loc.lat,
        lng: +loc.lon,
        type: loc.type.toLowerCase(),
        uuid: loc.place_id,
      }))
    )
  );
}
